import { Box, Paper, Stack, Theme, Typography } from "@mui/material";
import LeaveRequestComponent from "../components/LeaveRequestComponent";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

const Leave = () => {
  const { strings } = useContext(LanguageContext);
  return (
    <Box pr={1}>
      <Paper
        elevation={0}
        sx={(theme: Theme) => ({
          bgcolor: theme.palette.light.main,
        })}
      >
        <Box p={4}>
          <Stack
            direction={"row"}
            sx={{
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <Typography mt={2} variant="h3">
              {strings.leaverequests.title}
            </Typography>
          </Stack>
          <LeaveRequestComponent />
        </Box>
      </Paper>
    </Box>
  );
};

export default Leave;
